import { render, staticRenderFns } from "./Supplemental.vue?vue&type=template&id=72ca4391&lang=pug"
import script from "./Supplemental.vue?vue&type=script&lang=js"
export * from "./Supplemental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports